module.exports = __webpack_public_path__ + "static/assetsBox-8e013874c09228f76d09913614c0051c.png";